import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import {
  useFetchAuthorisation,
  authorisationConverter,
  useFetchUserData,
} from "../../utils/AppFunctions";
import config from "../../app-config";
import "react-toastify/dist/ReactToastify.css";
import AdminLayout from "../../layouts/AdminLayout";
import { fetch_all_mobile_campaigns } from "../../api/campaignsAPI";
import notify from "../../utils/IANotification";
import { captialise_first_letter, tidy_date } from "../../utils/helper";
import { MdAdd, MdCheck, MdEdit } from "react-icons/md";
import DataTable from "../../components/ui/DataTable";
import Button from "../../components/ui/Button";

export default function CampaignPushPage() {
  const navigate = useNavigate();
  let user_data = useFetchUserData();
  const [campaignData, setCampaignData] = useState([])
  const [loading, setLoading] = useState(true)
  const [query, setQuery] = useState("")

  useEffect(() => {
    fetchAllContact()
  }, [])

  const fetchAllContact = async () => {
    setLoading(true)
    const { data, error, message, status } = await fetch_all_mobile_campaigns()
    if (error) notify({ message: message || error, type: 'error' })
    setCampaignData(data?.reverse())
    setLoading(false)
  }

  const table_columns = [
    {
      header: "Title",
      accessor: "title"
    },
    {
      header: "Group",
      accessor: "group_data",
      modifier: (data, row) => row?.is_everyone == 1 ? null : `${data.length} groups`
    },
    {
      header: "Broadcast",
      accessor: "is_everyone",
      modifier: (data) => data == 1 ? <MdCheck /> : null
    },
    {
      header: "Scheduled Date & Time",
      accessor: "scheduled_datetime",
      modifier: (data) => data ? tidy_date(data) : null
    },
    {
      header: "Status",
      accessor: "status",
      modifier: (data) => captialise_first_letter(data)
    },
    {
      header: "Sent Receipt",
      accessor: "sent_at",
      modifier: (data) => data ? tidy_date(data) : null
    },
  ]
  return (
    <AdminLayout navSelected={"Push Notification"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Push Campaigns</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/campaigns/push/details?campaign_id=new")
            }}
          >
            <MdAdd size={16} />
            New Campaign
          </button>
        </>
      }
    >
      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          <DataTable
            columns={table_columns}
            data={campaignData}
            enableActions
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" icon={MdEdit} onClick={() => navigate(`/admin/campaigns/push/details?campaign_id=${row.id}`)}>
                    Edit
                  </Button>
                </div>
              )
            }}
          />
        </div>
      )}
    </AdminLayout>
  )
}